
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up/customer",
      function () {
        return require("private-next-pages/sign-up/customer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-up/customer"])
      });
    }
  